module.exports = __webpack_public_path__ + "static/media/banner.22d78468.png";